import React, { useEffect, useState } from "react";
import "./FyersAccessToken.css";
import { environment } from "environment/environment";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function FyersAccesstoken() {
    const [fyersAccessTokens, setFyersAccessTokens] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchAllFyersAccessTokens();
    }, []);

    const fetchAllFyersAccessTokens = async () => {
        setLoading(true);
        try {
            const response = await fetch(
                `${environment.baseUrl}/fyersone/get-all-fyers-access-token`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                }
            );

            const res = await response.json();

            if (res.status) {
                setFyersAccessTokens(res.data || []);

            }
        } catch (error) {
            toast.error("Failed to load access tokens");
        } finally {
            setLoading(false);
        }
    };

    // ✅ ENHANCED generate token handler
    const handleGenerateToken = async () => {
        try {
            setLoading(true);

            const response = await fetch(
                `${environment.baseUrl}/fyersone/login`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                }
            );

            const res = await response.json();

            if (res.status) {
                toast.success("FYERS access token generated successfully", {
                          autoClose: 1000,
                          onClose: () => {
                            setLoading(false);
                          },
                        });
                fetchAllFyersAccessTokens();
            } else {
                toast.error("Token generation failed");
            }
        } catch (error) {
            toast.error("Error while generating token");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fyers-access-token-page">
            <ToastContainer position="top-center" autoClose={3000} />

            <header className="header">
                <nav className="nav-container">
                    <div className="left-nav header-flex">
                        <div className="logo-container">
                            <img
                                src="/assets/images/noptionwave-logo-1.png"
                                className="header-logo"
                                alt="noptionwave logo"
                            />
                        </div>
                    </div>
                </nav>
            </header>

            {/* 🔹 Action bar */}
            <div className="table-action-bar">
                <div className="action-left">
                    <h3 className="page-title">Fyers Access Tokens</h3>
                </div>
                <div className="action-right">
                    <button
                        className="generate-token-btn"
                        onClick={handleGenerateToken}
                        disabled={loading}
                    >
                        {loading ? (
                            <span className="btn-spinner">Generating token......</span>
                        ) : (
                            "Generate Fyers Access Token"
                        )}
                    </button>
                </div>
            </div>

            <div className="table-container">
                <table className="responsive-table table-bordered text-center sticky-header stock-day-range-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>DATE</th>
                            <th>TIME</th>
                            <th>GENERATE BY</th>
                            <th>FYERS ACCESS TOKEN</th>
                        </tr>
                    </thead>

                    <tbody>
                        {fyersAccessTokens?.length > 0 ? (
                            fyersAccessTokens.map((row, idx) => (
                                <tr key={idx}>
                                    <td>{row.id ?? "--"}</td>
                                    <td>{row.createdDate ?? "--"}</td>
                                    <td>{row.createdTime ?? "--"}</td>
                                    <td>{row.generatedBy ?? "--"}</td>
                                    <td>
                                        <span className="token-box">
                                            {row.fyersAccessToken ?? "--"}
                                        </span>
                                    </td>

                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5">Waiting for live data...</td>
                            </tr>
                        )}
                    </tbody>

                    <tfoot className="fixed-footer">
                        <tr className="footer-left">
                            <td colSpan="5">noptionwave © 2026</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    );
}
